import gql from 'graphql-tag'

export const invitesQuery = gql`
    query getInvites($eventSlug: EventID!, $search: String, $first: Int, $after: ID, $sort: InviteOrder, $status: InviteStatus) {
        event(id: $eventSlug) {
            invites(search: $search, first: $first, after: $after, orderBy: $sort, status: $status) {
                edges {
                    node {
                        id
                        firstName
                        lastName
                        email
                        created
                        mailSent
                        status
                        isStaff
                        tags {
                            color
                            text
                        }
                    }
                }
                totalCount
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    endCursor
                }
            }
        }
    }
`

export const eventInviteConfigQuery = gql`
    query getEventInviteConfig($eventSlug: EventID!) {
        event(id: $eventSlug) {
            isActivationRequested
            paid
            inviteOnly
            inviteMailSenderName
            inviteMailReplyTo
            inviteMailSubject
            inviteMailNameFormat
            inviteMailSalutation
            inviteMailIntro
            inviteMailOutro
        }
    }
`

export const inviteByIdQuery = gql`
    query getInviteById($eventSlug: EventID!, $filters: EventInviteFilter) {
        event(id: $eventSlug) {
            invites(first: 1, filters: $filters) {
                edges {
                    node {
                        id
                        firstName
                        lastName
                        email
                        jobtitle
                        company
                        about
                        website
                        twitter
                        facebook
                        linkedin
                        instagram
                        googlePlus
                        status
                        locationType
                        tags {
                            id
                            text
                            color
                        }
                    }
                }
            }
        }
    }
`

export const statusOverviewQuery = gql`
    query getStatusOverview($eventSlug: EventID!, $status: InviteStatus) {
        event(id: $eventSlug) {
            invites(status: $status) {
                totalCount
            }
        }
    }
`

export const attendeeTagsQuery = gql`
    query getAttendeeTags($eventSlug: EventID!) {
        event(id: $eventSlug) {
            userTags {
                id
                text
                color
                category {
                    id
                    text
                    order
                }
            }
        }
    }
`

export const tagsQuery = gql`
    query userTags($eventId: EventID!) {
        event(id: $eventId) {
            userTags {
                id
                text
                color
                order
                category {
                    id
                    text
                    order
                }
            }
        }
    }
`

export const categoriesQuery = gql`
    query attendeeTagCategories($eventId: EventID!) {
        event(id: $eventId) {
            attendeeTagCategories {
                id
                order
                text
            }
        }
    }
`
